import { render, staticRenderFns } from "./ProgramDetail.vue?vue&type=template&id=5def0a5d&scoped=true&"
import script from "./ProgramDetail.vue?vue&type=script&lang=js&"
export * from "./ProgramDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProgramDetail.vue?vue&type=style&index=0&id=5def0a5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5def0a5d",
  null
  
)

export default component.exports